import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { DynamoDBClient } from "@aws-sdk/client-dynamodb";
import { DynamoDBDocumentClient, ScanCommand } from "@aws-sdk/lib-dynamodb";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import awsconfig from '../aws-exports';
import RsvpTable from './RsvpTable';
import './RsvpManager.css';

function RsvpManager() {
  const [rsvpData, setRsvpData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRsvpData();
  }, []);

  async function fetchRsvpData() {
    setIsLoading(true);
    setError(null);
    
    try {
      // Get credentials from Amplify Auth
      const currentSession = await Amplify.Auth.currentSession();
      const idToken = currentSession.getIdToken().getJwtToken();
      
      // Configure credential provider
      const region = awsconfig.aws_project_region;
      const identityPoolId = awsconfig.aws_cognito_identity_pool_id;
      
      // Create credentials provider
      const loginKey = `cognito-idp.${region}.amazonaws.com/${awsconfig.aws_user_pools_id}`;
      const logins = {};
      logins[loginKey] = idToken;
      
      const credentialsProvider = fromCognitoIdentityPool({
        client: new CognitoIdentityClient({ region }),
        identityPoolId: identityPoolId,
        logins: logins
      });

      // Create DynamoDB client
      const dynamoClient = new DynamoDBClient({
        region,
        credentials: credentialsProvider
      });
      
      // Create DynamoDB Document client
      const docClient = DynamoDBDocumentClient.from(dynamoClient, {
        marshallOptions: { removeUndefinedValues: true }
      });
      
      // Create scan command
      const tableName = 'erikaandrew_wedding';
      const scanCommand = new ScanCommand({
        TableName: tableName,
        ConsistentRead: true
      });
      
      // Execute scan command
      const result = await docClient.send(scanCommand);
      setRsvpData(result.Items || []);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching RSVP data:', err);
      setError(`Failed to load RSVP data: ${err.message}`);
      setIsLoading(false);
    }
  }

  return (
    <div className="rsvp-manager">
      <h1>RSVP Management</h1>
      {isLoading ? (
        <div className="loading-message">Loading RSVP data...</div>
      ) : error ? (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={fetchRsvpData} className="retry-button">Try Again</button>
        </div>
      ) : (
        <RsvpTable data={rsvpData} refreshData={fetchRsvpData} />
      )}
    </div>
  );
}

export default RsvpManager;